import { render, staticRenderFns } from "./imgView.vue?vue&type=template&id=a57a632e&scoped=true"
import script from "./imgView.vue?vue&type=script&lang=js"
export * from "./imgView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57a632e",
  null
  
)

export default component.exports